import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import { LOAN_PROGRAMS } from "../../utils/zhl-calculator.esm.js";
import CashOutRefinanceCalculator from "./CashOutRefinanceCalculator.esm.js";
import { FieldConfig } from "./CashOutRefinanceCalculator.utils.esm.js";
const CashOutRefinanceCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      homeValue,
      currentMortgageBalance,
      newLoanTerm,
      newInterestRate,
      adjustCashOutAmount,
      fees,
      rollFees
    } = attrs;
    const defaultValues = {
      homeValue,
      currentMortgageBalance,
      newLoanTerm,
      newInterestRate,
      adjustCashOutAmount,
      fees,
      rollFees
    };
    return /* @__PURE__ */ jsx(CashOutRefinanceCalculator, { ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/cashout-refinance-calculator",
    title: "Cash-Out Refinance Calculator",
    description: "Zillow`s cash-out refinance calculator can help you determine what your monthly payment would be and see if this loan is the right fit for your financial situation.",
    icon: "money-alt",
    keywords: ["mortgages", "calculators", "cash", "refinance"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Calculators",
    attributes: {
      [FieldConfig.homeValue.name]: {
        type: "number",
        default: 3e5,
        label: "Default home value",
        control: "number"
      },
      [FieldConfig.currentMortgageBalance.name]: {
        type: "number",
        default: 1e4,
        label: "Default Mortgage balance",
        control: "number"
      },
      [FieldConfig.newInterestRate.name]: {
        type: "number",
        label: "Default new interest rate",
        default: 4.176,
        control: "number"
      },
      [FieldConfig.adjustCashOutAmount.name]: {
        type: "number",
        label: "Default adjust cash-out amount",
        default: 19e4,
        control: "number"
      },
      [FieldConfig.newLoanTerm.name]: {
        type: "string",
        default: LOAN_PROGRAMS.fixed0Year,
        label: "Default current term",
        control: "select",
        choices: FieldConfig.newLoanTerm.options
      },
      [FieldConfig.fees.name]: {
        type: "number",
        default: 1e3,
        label: "Default refinance fees",
        control: "number"
      },
      [FieldConfig.rollFees.name]: {
        type: "boolean",
        default: 1e3,
        label: "Default roll fees",
        control: "boolean"
      }
    }
  }
};
export {
  CashOutRefinanceCalculatorBlock as default
};
